<template>
    <transition name="fade">
        <div class="Viewer3D" v-show="viewer3DVisible" :style="{ zIndex: fullScreen ? '99999999' : '1' }">
            <div class="v3-container" :style="{ width: fullScreen ? '100%' : '90%' , height: fullScreen ? '100%' : '85%' , marginTop: fullScreen ? '0px' : '30px' ,  borderRadius: fullScreen ? '0px' : '10px'}">
                
                <!-- Toolbar -->
                <div class="v3-bar">
                    <transition name="fade">
                        <p class="v3-bar-name" v-if="name">{{name}}</p>
                    </transition>
                    <div class="v3-bar-buttons">  
                        <!-- <md-button class="md-icon-button" @click="toggleFullsize()" :class="{ 'v3-active': fullScreen }">
                            <FullScreenIcon v-if="!fullScreen"/>
                            <FullScreenExitIcon v-else/>
                        </md-button> -->
                        <md-button class="md-icon-button" @click="toggleViewer3D()" style="margin-right: 0;">
                            <CloseIcon class="closeIcon"/>
                        </md-button>
                    </div> 
                </div>

                <!-- Loadingscreen -->
                <div id="v3-loadingScreen" class="v3-loadingscreen">
                    <div>
                        <img class="v3-logo" :src="logoURL" alt="">
                        <svg class="v3-animation" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                            <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                                <animateTransform attributeName="transform" attributeType="XML"  type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" />
                            </path>
                        </svg>
                    </div>
                </div>

                <!-- Canvas -->
                <Canvas id="v3-canvas" class="v3-canvas" :style="{ borderRadius: fullScreen ? '0px' : '0px 0px 10px 10px'}"/>  

            </div>         

        </div>  
    </transition>
</template>

<style scoped>
    .Viewer3D{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000000d0;
    }
    .v3-container{
        position: absolute;
        margin-top: 30px;
        background: white;
        border-radius: 10px;
        transition: width .4s ease, height .4s ease;
    }
    .v3-bar{
        padding: 3px;
        padding-right: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.774);
        display: flex;
        position: relative;
    }
    .v3-bar-name{
        width: 100%;
        text-align: center;
        font-size: 18px;
        margin: auto 0;
    }
    .v3-bar-buttons{
        margin-left: auto;
    }
    .v3-canvas{
        width: 100%;
        height: calc(100% - 46px);
        border-radius: 0px 0px 10px 10px;
        outline: none;
    }
    .material-design-icon {
        height: 2.4em;
        width: 2.4em;
    }
    .material-design-icon > .material-design-icon__svg {
        fill: black;
        height: 2.4em;
        width: 2.4em;
    }
    .v3-active .material-design-icon  > .material-design-icon__svg{
        fill: white !important;
    }
    .v3-active.md-button{
        background: var(--primaryColor);
    }
    .md-button{
        background: transparent;
        padding: 0;
        width: 30px;
    }
    .material-design-icon.closeIcon {
        height: 2.5em;
        width: 2.5em;
    }
    .material-design-icon.closeIcon> .material-design-icon__svg {
        fill: rgb(252, 113, 113);
        height: 2.5em;
        width: 2.5em;
    }
    .v3-loadingscreen{
        pointer-events: none;
        opacity: 0;
        transition: 1s opacity ease-in-out;
        position: absolute;
        width: 100%;
        height: calc(100% - 46px);
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0px 0px 10px 10px;
    }
    .v3-logo{
        width: 350px;
    }
    .v3-animation{
        fill: var(--primaryColor);
        width: 200px;
        height: 200px;
        margin: auto;
        display: block;
    }
</style>
    
<script>
import {mapGetters,mapMutations,mapState} from 'vuex';
import * as BABYLON from 'babylonjs';
import 'babylonjs-loaders';

// Icons
import CloseIcon from 'vue-material-design-icons/Close.vue'
import FullScreenIcon from 'vue-material-design-icons/Fullscreen.vue'
import FullScreenExitIcon from 'vue-material-design-icons/FullscreenExit.vue'
import OpenInNewIcon from 'vue-material-design-icons/OpenInNew.vue'

export default {
    components: {CloseIcon,OpenInNewIcon,FullScreenIcon,FullScreenExitIcon},
    inject: ['toggleCommunication'], 
    data: function () {
        this.meshURL = "",
        this.mesh = null,
        this.assetsManager = null,
        this.shadowGenerator = null,
        this.engine = null,
        this.scene = null,
        this.intervalID = null,
        this.background = null,
        this.scaleX = null,
        this.scaleY = null,
        this.scaleZ = null,
        this.loadedMeshes = []
        return {
            viewer3DVisible: false,
            fullScreen: false,
            name: null,
        }
    }, 
    computed: {
        ...mapGetters(['logoURL','localUser','localUserID','followModeratorMode','sendingFollowModerator']),
        ...mapState({session: (state) => state.session.openTokSession}), 
    },
    watch: {
        viewer3DVisible(){
            if(this.viewer3DVisible){
                this.showViewer();
                if(this.sendingFollowModerator)
                    this.startSendingSignal();
            }else{
                this.hideViewer();
                if(this.sendingFollowModerator)
                    this.stopSendingSignal();
            } 
        },

        session: function(){
            if(this.session){
                let lastTimeout;
                this.session.on("signal:followModerator3DViewer", (event) => {
                    clearTimeout(lastTimeout);

                    let data = event.data.split(",");
                    let userID = data[0];
                    if (userID == this.localUserID)
                        return;

                    console.log("followModerator3DViewer signal recieved");
                    let viewerVisibility = data[1] === "true";
                    let meshUrl = data[2];
                    let cameraAlpha = parseFloat(data[3]);
                    let cameraBeta = parseFloat(data[4]);
                    let cameraZoom = parseFloat(data[5]);
                    let scaleX = parseFloat(data[6]);
                    let scaleY = parseFloat(data[7]);
                    let scaleZ = parseFloat(data[8]);
                    let name = data[9];

                    let camera = this.scene.activeCamera;
                    camera.detachControl();

                    if(this.viewer3DVisible != viewerVisibility){
                        this.name = name;
                        this.scaleX = scaleX;
                        this.scaleY = scaleY;
                        this.scaleZ = scaleZ;
                        this.meshURL = meshUrl; 
                        this.viewer3DVisible = !this.viewer3DVisible;
                        this.setDialogueOpen(this.viewer3DVisible);
                    }
                    camera.alpha = cameraAlpha;
                    camera.beta = cameraBeta;
                    camera.radius = cameraZoom;

                    lastTimeout = setTimeout(() => {
                        camera.attachControl(document.getElementById("v3-canvas"), true, false,4);
                    }, 500);
                    
                });
            }
        },

        sendingFollowModerator(){
            // Moderator starts follow mode when viewer already open
            if(!this.intervalID && this.viewer3DVisible)
                this.startSendingSignal();
            
            // Moderator stops follow mode when viewer still open
            if(!this.sendingFollowModerator && this.intervalID && this.viewer3DVisible)
                this.stopSendingSignal();
        }
    },
	methods: {
        ...mapMutations(["setDialogueOpen"]),

        toggleFullsize(){
            this.fullScreen = !this.fullScreen;
            this.toggleCommunication();
        },

        toggleViewer3D(){
            if(!this.followModeratorMode || this.sendingFollowModerator){
                this.viewer3DVisible = !this.viewer3DVisible;
                this.setDialogueOpen(this.viewer3DVisible);
            }
        },

        startSendingSignal(){
            this.intervalID = setInterval(() => {
                let camera = this.scene.activeCamera;
                const signalData = {
                    type: "followModerator3DViewer", 
                    data: this.localUserID + "," + this.viewer3DVisible + "," + this.meshURL + "," + camera.alpha + "," + camera.beta + "," + camera.radius + "," + this.scaleX + "," + this.scaleY + "," + this.scaleZ +  "," + this.name,
                };
                this.session.signal(signalData, (error) => {
                    if(error) console.log(['signal error (', error.code, '): ', error.message].join(''));
                    else console.log('followModerator3DViewer signal sent');   
                });
            }, 20);
        },

        stopSendingSignal(){
            clearInterval(this.intervalID);
            this.intervalID = null;

            let camera = this.scene.activeCamera;
            const signalData = {
                type: "followModerator3DViewer", 
                data: this.localUserID + "," + this.viewer3DVisible + "," + this.meshURL + "," + camera.alpha + "," + camera.beta + "," + camera.radius,
            };
            this.session.signal(signalData, function (error) {
                if(error) console.log(['signal error (', error.code, '): ', error.message].join(''));
                else console.log('followModerator3DViewer signal sent');   
            });
        },

        initDialogue: function(e) {
            this.meshURL = e.detail.meshURL;
            this.scaleX = e.detail.scaleX;
            this.scaleY = e.detail.scaleY;
            this.scaleZ = e.detail.scaleZ;
            this.name = e.detail.name;
            this.toggleViewer3D();
        },
        
        showViewer(){
            // Reset Camera
            this.scene.activeCamera.alpha = 1;
            this.scene.activeCamera.beta = 1;
            
            // Load new Model
            if(this.loadedMeshes.find(mesh => mesh.name == this.meshURL)){
                this.loadedMeshes.find(mesh => mesh.name == this.meshURL).setEnabled(true);
            }else{
                var meshTask = this.assetsManager.addMeshTask("", "", "",this.meshURL);
                meshTask.onSuccess = (task) => {   
                    task.loadedMeshes[0].name = this.meshURL;
                    this.loadedMeshes.push(task.loadedMeshes[0]);
                    task.loadedMeshes[0].scaling = new BABYLON.Vector3(this.scaleX,this.scaleY,this.scaleZ);
                    // task.loadedMeshes.forEach(e => {
                    //     // this.shadowGenerator.getShadowMap().renderList.push(e);
                    //     // e.receiveShadows = true;
                    // });

                    this.scene.meshes.forEach(m => {
                        m.isPickable = false; 
                    });  

                    let backgroundURL;
                    switch (task.loadedMeshes[1].parent.parent.name) {
                        case "Curemaster":
                        case "PCR":
                        case "PCI":
                        case "PCR2":
                        case "PCR3":
                            backgroundURL = "Presses.jpg";
                            break;
                        case "Convex":
                        case "MXBottom":
                        case "MXTop":
                        case "ConvexUTandem":
                            backgroundURL = "Mixing.png";
                            break;
                        case "HFOne":
                        case "Trommel_1":
                            backgroundURL = "Tire1.png";
                            break;
                        default:
                            break;
                    }

                    this.background = new BABYLON.Layer("background", "./media/HF Group/" + backgroundURL, this.scene);
                    this.background.isBackground = true;
                    this.background.texture.level = 0;

                    this.engine.resize();         
                }
                this.assetsManager.load();
            }

            this.engine.runRenderLoop(()=> { this.scene.render(); });
        },

        hideViewer(){
            this.loadedMeshes.find(mesh => mesh.name == this.meshURL).setEnabled(false);

            this.engine.stopRenderLoop();

            if(this.fullScreen)
                this.toggleFullsize();
        },

        initScene(){
            const canvas = document.getElementById("v3-canvas");
            this.engine = new BABYLON.Engine(canvas,true,{xrCompatible: false});
            this.engine.enableOfflineSupport = true;
            BABYLON.Database.IDBStorageEnabled = true;
            BABYLON.Engine.OfflineProviderFactory = (urlToScene, callbackManifestChecked, disableManifestCheck) => {
                return new BABYLON.Database(urlToScene, callbackManifestChecked, true);
            };

            function customLoadingScreen() {}
            customLoadingScreen.prototype.displayLoadingUI = function () {
                window.document.getElementById("v3-loadingScreen").style.opacity = 1;
            };
            customLoadingScreen.prototype.hideLoadingUI = function () {
                window.document.getElementById("v3-loadingScreen").style.opacity = 0;
            };
            this.engine.loadingScreen = new customLoadingScreen();


            this.scene = new BABYLON.Scene(this.engine);
            // this.scene.debugLayer.show();
            
            var camera = new BABYLON.ArcRotateCamera("Camera", 1.55,  1.25, 110, new BABYLON.Vector3(0, 10, 0), this.scene);
            camera.upperAlphaLimit = 50;
            camera.lowerAlphaLimit = -50;
            camera.lowerRadiusLimit = 50;
            camera.upperRadiusLimit = 200;
            camera.panningSensibility = 500;
            camera.attachControl(canvas, true, false,4);

            // var postProcess = new BABYLON.FxaaPostProcess("fxaa", 1.0,  camera);
            // postProcess.samples = 116;

            let light2 = new BABYLON.DirectionalLight("", new BABYLON.Vector3(-0.6, -1, -2), this.scene);
            light2.position = new BABYLON.Vector3(200,200,200);
            this.shadowGenerator = new BABYLON.ShadowGenerator(512, light2);
            // this.shadowGenerator.usePercentageCloserFiltering = true;
            // this.shadowGenerator.blurKernel = 64;
            // this.shadowGenerator.frustumEdgeFalloff = 1.0;

            this.scene.environmentTexture = new BABYLON.HDRCubeTexture("./media/HF Group/background.hdr",this.scene, 128, false, true, false, true);

            this.assetsManager = new BABYLON.AssetsManager(this.scene);

            const resizeObserver = new ResizeObserver(() => {
                setTimeout(() => {
                    this.engine.resize();
                }, 0);
            });
            resizeObserver.observe(canvas);
        }
    },

    // Add Eventlistener that displays and initializes this dialogue. Event gets fired inside URLButton component
    mounted: function(){
        this.initScene();
        window.addEventListener('openViewer3D',this.initDialogue);
    }
}

</script>